import { OfferT } from "../../../../../domain";
import React from "react";
import { ResizeIcon } from "../../../../../../../shared/infrastructure/ui/assets/icons/resize";
import { SeeNegociations } from "../../../components/modals/negociations";
import {
  Modal,
  useDisclosure,
} from "../../../../../../../shared/infrastructure";

type NegotiationColumnProps = {
  data?: OfferT;
};

export const NegotiationColumn = ({
  data,
}: NegotiationColumnProps): React.ReactElement => {
  const { isOpen, close, open } = useDisclosure();

  return (
    <React.Fragment>
      <button onClick={open}>
        <ResizeIcon />
      </button>

      {data && (
        <Modal
          open={isOpen}
          onClose={close}
          content={<SeeNegociations close={close} offer={data} />}
          classNames={{
            content:
              "overflow-x-scroll overflow-y-hidden p-[20px] min-w-[1013px] max-h-[420px] w-[1024px]",
            paper: "rounded-[5px] max-w-[85%]",
          }}
        />
      )}
    </React.Fragment>
  );
};
